import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from '@reach/router';
import Image from '../Image';
import { IconCheck, IconExclamationMark } from '../Icons';

import { StyledGridItem, StyledTooltip, StyledImageButton, StyledSelectedIconWrapper, StyledSoldOutOverlay } from './VisualizerProductListItemStyles';

var _ref = React.createElement(
  StyledSoldOutOverlay,
  null,
  'SOLD OUT'
);

var _ref2 = React.createElement(IconExclamationMark, null);

var _ref3 = React.createElement(IconCheck, { stroke: '#FFFFFF' });

var VisualizerRoomListItem = function VisualizerRoomListItem(props) {
  var handleClick = function handleClick() {
    document.querySelector('header').getBoundingClientRect().height;
    props.designYourOwn ? scrollToBedding() : navigate(props.room.url);
  };

  var scrollToBedding = function scrollToBedding() {
    navigate('?selected=');
    document.querySelector('.category--beddings').scrollIntoView({ behavior: 'smooth', block: 'center' });

    if (!props.categoryActive['beddings']) props.handleCategoryActive('beddings');
    props.handleCategoryActive('collections');
  };

  return React.createElement(
    StyledGridItem,
    null,
    React.createElement(
      StyledTooltip,
      null,
      props.room.name
    ),
    React.createElement(
      StyledImageButton,
      { onClick: handleClick },
      props.room.image ? React.createElement(Image, { alt: props.room.name, src: props.room.image }) : null,
      false && _ref,
      React.createElement(
        StyledSelectedIconWrapper,
        null,
        false ? _ref2 : _ref3
      )
    )
  );
};

VisualizerRoomListItem.propTypes = {
  room: PropTypes.object.isRequired,
  isStaging: PropTypes.bool.isRequired,
  designYourOwn: PropTypes.bool.isRequired,
  handleCategoryActive: PropTypes.func.isRequired,
  categoryActive: PropTypes.object.isRequired
};

export default VisualizerRoomListItem;